import OnePlatformCommonActions from "@frameworks/web/redux/actions/common/commonActions";
import { DPI_DETAILS } from "@frameworks/web/redux/interfaces/Reports/iDpInterest";
class DpiDetailsActions extends OnePlatformCommonActions {
    getDpInterestDetails(dpiDetails, type) {
        this.dispatch({
            type: DPI_DETAILS,
            payload: { dpiDetails },
            reducerName: type,
        });
    }
}
export default DpiDetailsActions;
